import SubPartnerDetail from '../../modules/PartnerNetwork/SubPartnerDetail.jsx';

function PageSubPartner() {
    return <SubPartnerDetail />;
}

export default PageSubPartner;
